import moment from 'moment';
import numeral from 'numeral';

export default {
  isEmpty: function (val) {
    return val === '' || val === null || val === -1 ? '-' : val
  },
  showEmtpy: function () {
    return "-";
  },
  dataListFormat: function (val, format, row) {
    if (!format) {
      return val;
    }
    if (typeof (format) == "function") {
      return filters[format()](val);
    } else if (typeof (format) == "object") {
      let funName = format.funName;
      let type = row ? row[format.paramProp] : undefined;
      if (!type) {
        type = "";
      }
      return filters[funName](val, type);
    } else {
      return filters[format](val);
    }
  },
  currency(value, type) {
    let mapping = {
      127001: "rmb",
      127002: "usd",
      127003: "hk"
    }
    return filters[mapping[type]](value);
  },

  usd: function (val) {
    return "$" + numeral(val).format('0,0.00');
  },
  rmb: function (val) {
    return "￥" + numeral(val).format('0,0.00');
  },
  hk: function (val) {
    return "HK$" + numeral(val).format('0,0.00');
  },

  date: function (val, format) {
    if (val) {
      return moment(val).format(format || 'YYYY-MM-DD');
    } else {
      return filters.showEmtpy();
    }
  },
  dateTime: function (val, format) {
    if (val) {
      return moment(val).format(format || 'YYYY-MM-DD HH:mm:ss');
    } else {
      return filters.showEmtpy();
    }
  },
  percent: function (val) {
    return numeral(val).format('0.00%');
  },
  number: function (val) {
    return numeral(val).format('0,000.00');
  },
  integer: function (val) {
    return numeral(val).format('0,000');
  },
  getweek: function (val) {
    if (val) {
      return moment(val).format('YYYY/MM/DD HH:mm:ss');
    } else {
      return filters.showEmtpy();
    }
  },
  getday: function (val) { //获取星期几
    var weekDays = ["星期天", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
    if (val) {
      return weekDays[moment(val).format('d')];
    } else {
      return filters.showEmtpy();
    }
  },
  days: function (val) { //获取天数
    if (val) {
      return moment(val).format('Do').split('th')[0] + "日";
    } else {
      return filters.showEmtpy();
    }
  },
  connectRange(val1, val2) {
    return `${val1} - ${val2}`
  },
  moneyRange(data) {
    if (data.length != 0) {
      if (data[1] == -1) {
        return "￥" + numeral(data[0]).format('0,0.00') + "+"
      } else if (data[0] == -1) {
        return "￥" + numeral(data[1]).format('0,0.00') + "-"
      }
      return "￥" + numeral(data[0]).format('0,0.00') + " ~ ￥" + numeral(data[1]).format('0,0.00')
    } else {
      return filters.showEmtpy()
    }
  },
  hideMobile(val) {
    if (val) {
      return val.replace(/(\d{3})(\d{4})/, '$1****')
    }
    return filters.showEmtpy()
  },
  hideTel(val) {
    if (val) {
      return val.replace(/(\d{4})$/, '****')
    }
    return filters.showEmtpy()
  },
  preFilter: function (val, option) {
    if (!option) {
      return val
    } else {
      return filters[option](val);
    }
  },
  splitarray: function (val) {
    return val && val.length > 0 ? val.join(',') : '-'
  },
  nullValue: function (value) {
    return value != null && value != undefined && value != '' ? value : '-'
  },
  overMillion: function (val) {
    if (val.toString().length > 4) {
      return (Number(val.toString().replace(/,+/g, "")) / 10000).toFixed(1) + 'w'
    } else {
      return val
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/filters.js